import gql from 'graphql-tag';
import ImageDataFragment from './ImageData.gql';

export default gql`
  fragment ListicleItemFragment on ListicleItem {
    id
    type
    data {
      image {
        ...ImageDataFragment
      }
      title
      html
    }
  }
  ${ImageDataFragment}
`;
